import { useDeleteStore } from '../../hooks';
import { ApiKeyTemplateDeleteModalView } from '../../components/ApiKeyTemplateDeleteModalView';

export const ApiKeyTemplateDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <ApiKeyTemplateDeleteModalView {...deleteStore} />;
};
